module.exports = __webpack_public_path__ + "static/pitpay_rectangle-e2e689a605f60f1cbadd1aa123ac30b8.svg";